/// <amd-module name="VSS/Redux/Modules/TTIMonitor/PostTTI" />
import * as React from "react";
import { connect } from "react-redux";
import { ITTIAwareState } from "VSS/Redux/Modules/TTIMonitor/TTIMonitorContracts";
import { isPageInteractive } from "./TTIMonitorSelector";

export interface IPostTTIMappedProps {
    shouldRender: boolean;
}

export interface IPostTTIProps {
    children?: React.ReactNode;
}

/**
 * Component which only renders its content after TTI has been marked
 */
class PostTTIComponent extends React.Component<IPostTTIProps & IPostTTIMappedProps> {
    public render(): JSX.Element | null {
        if (this.props.shouldRender) {
            return <>{this.props.children}</>;
        } else {
            return null;
        }
    }
}

function mapStateToProps(state: ITTIAwareState): IPostTTIMappedProps {
    return {
        shouldRender: isPageInteractive(state)
    };
}

/**
 * Component which only renders its content after TTI has been marked
 */
export const PostTTI = connect(mapStateToProps)(PostTTIComponent);
